import React from 'react';
import { PARTNER_EMAIL } from '../constants';
import PartnersCtaButton from '../components/PartnersCtaButton';
import { usePartnersStrings } from '../usePartnersStrings';

const PartnersFinalCta: React.FC = () => {
  const s = usePartnersStrings();

  return (
    <section className="container-chisme py-10 lg:py-16">
      <div
        className="flex flex-col items-center gap-8 overflow-hidden rounded-[40px] px-6 py-10 text-center sm:px-10 sm:py-12 lg:px-16 lg:py-[72px]"
        style={{
          backgroundImage: 'linear-gradient(129deg, rgb(255, 217, 238) 0%, rgb(255, 192, 225) 100%)',
        }}
      >
        <h2 className="font-instrument text-4xl leading-[1.05] tracking-[-0.03em] text-[#2a0f2a] sm:text-6xl lg:text-[80px] lg:leading-[0.88]">
          <span className="block">{s.finalCta.titleLine1}</span>
          <span className="block italic text-chisme-primary">{s.finalCta.titleLine2}</span>
        </h2>
        <p className="max-w-xl font-jakarta text-base leading-relaxed text-[#5a3158] lg:text-lg lg:leading-[26px]">
          {s.finalCta.subtitle}
        </p>
        <div className="flex flex-col items-center gap-3">
          <PartnersCtaButton variant="dark" showArrow={false}>
            {s.cta.registerBusiness}
          </PartnersCtaButton>
          <p className="font-jakarta text-sm text-[#5a3158]/70">
            {s.finalCta.footnote} {PARTNER_EMAIL}
          </p>
        </div>
      </div>
    </section>
  );
};

export default PartnersFinalCta;
